import React from 'react';
import styled from 'styled-components';

interface ToastNotificationProps {
  color: string;
  message: {
    platformState?: string;
    nextPlatformState: string;
    nextPlatformStateAt?: string;
  };
}

export const ToastNotification: React.FC<ToastNotificationProps> = ({
  message,
  color,
}) => {
  const { platformState, nextPlatformState, nextPlatformStateAt } = message;
  return (
    <Container>
      <FlagColor color={color}> </FlagColor>
      <Content>
        {Boolean(platformState) && platformState !== '' && (
          <Row>
            <Opacity>Platform State </Opacity>
            {platformState}
          </Row>
        )}
        <Row>
          <Opacity>Next Platform State </Opacity>
          {nextPlatformState}
        </Row>
        {Boolean(nextPlatformStateAt) && nextPlatformStateAt !== '' && (
          <Row>
            <Opacity>Next Platform State At </Opacity>
            {nextPlatformStateAt}
          </Row>
        )}
      </Content>
    </Container>
  );
};

export const Container = styled.div`
  box-sizing: border-box;
  margin: 0px;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: max-content 1fr;
  min-width: 368px;
`;

export const Content = styled.div`
  padding: 8px 14px;
  font-family: 'IBM Plex Sans', sans-serif;
  height: 100%;
  font-weight: bold;
`;

export const Row = styled.p`
  margin: 0px;
`;

export const FlagColor = styled.div<{ color: string }>`
  width: 14px;
  height: 100%;
  min-height: 100%;
  background-color: ${({ color }) => color};
  border-radius: 6px 0px 0px 6px;
`;

export const Opacity = styled.span`
  margin-right: 4px;
  opacity: 0.7;
`;
